import React, { useMemo } from 'react'

import { HorizontalScrollTable } from 'components/ArticleComponents'
import { NoTableIcon, YesTableIcon } from './TableIcons'

const DEFAULT_VALUES = {
	yes: YesTableIcon,
	no: NoTableIcon,
}

const DEFAULT_CAPABILITIES = {
	RECURRING: {
		header: 'Recurring payments',
		values: DEFAULT_VALUES,
	},
	REFUNDS: {
		header: 'Refunds',
		values: DEFAULT_VALUES,
	},
	CAPTURE_FLOW: {
		header: 'Separated capture',
		values: {
			AUTOMATIC: 'Automatic capture after authorization',
			MANUAL: 'Manual capture',
		},
	},
	SETTLEMENT_TIME: {
		header: 'Settlement time',
		values: {
			IMMEDIATE: 'Immediate',
			FEW_DAYS: 'Within 2-3 days',
		},
	},
}

const CapabilityTable = ({ capabilities }) => {
	const data = useMemo(
		() =>
			capabilities.map(capability => {
				const builtIn = DEFAULT_CAPABILITIES[capability.id]
				if (builtIn) {
					return {
						header: builtIn.header,
						value: builtIn.values[capability.value] ?? DEFAULT_VALUES[capability.value] ?? capability.value,
					}
				}

				return {
					header: capability.id,
					value: DEFAULT_VALUES[capability.value] ?? capability.value,
				}
			}),

		[capabilities],
	)

	if (!capabilities?.length) {
		return null
	}

	return (
		<HorizontalScrollTable>
			<thead>
				<tr>
					{data.map(({ header }) => (
						<th key={header}>{header}</th>
					))}
				</tr>
			</thead>
			<tbody>
				<tr>
					{data.map(({ value }) => (
						<td key={value}>{value}</td>
					))}
				</tr>
			</tbody>
		</HorizontalScrollTable>
	)
}

export default CapabilityTable
